import React, {useEffect, useMemo, useState} from "react";
import {useFormik} from "formik";
import InputLabel from '@material-ui/core/InputLabel';
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import CardHeader from "@material-ui/core/CardHeader";
import SupplierAdminPage from "./SupplierAdminPage";
import { PuertoRicoMunicipalitySelect } from "../../../components/PuertoRicoMunicipalitySelect/PuertoRicoMunicipalitySelect";
import {useSelector} from "react-redux";
import {createExternalSupplier, fetchSuppliers, updateSupplierInformation} from "../AdminPagesCrud";
import {useParams} from "react-router-dom";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import * as Yup from "yup";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import Image from "react-bootstrap/Image";
import Select from "@material-ui/core/Select";
import FilledInput from "@material-ui/core/FilledInput";
import MenuItem from "@material-ui/core/MenuItem";

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};

function supplierIdToString(id) {
    if (id == null) return '';
    if (typeof id === 'object' && id.toString) return id.toString();
    return String(id);
}

/** Maps API / Mongo supplier doc to stable strings for Formik controlled fields. */
function normalizeSupplierForForm(s) {
    if (!s) return {};
    const str = (v) => (v == null ? '' : String(v));
    return {
        entityName: str(s.entityName),
        pointOfContact: str(s.pointOfContact),
        Mas90VendorNumber: str(s.Mas90VendorNumber || s.slug),
        phoneNumber: str(s.phoneNumber),
        postalAddress: str(s.postalAddress),
        postalCity: str(s.postalCity),
        postalZipcode: str(s.postalZipcode),
        physicalAddress: str(s.physicalAddress),
        physicalCity: str(s.physicalCity),
        physicalZipcode: str(s.physicalZipcode),
        email: str(s.email),
        description: str(s.description),
        logoPath: str(s.logoPath),
        active: s.active !== undefined && s.active !== null && s.active !== '' ? s.active : '',
        isOfficial: s.isOfficial !== undefined && s.isOfficial !== null && s.isOfficial !== '' ? s.isOfficial : '',
    };
}


function EditOrAddSupplier({ supplierInformation, edit, setEdit, setShowSnackbar, showSnackbar, openSupplier, 
                                setOpenSupplier, setSelectedSupplier, initialValues, intl}) {

    // const { intl } = props;
    const [cancel, setCancel] = useState(false);
    const [physicalCity, setPhysicalCity] = useState(() => supplierInformation.physicalCity ?? '');
    const [postalCity, setPostalCity] = useState(() => supplierInformation.postalCity ?? '');
    const [logo, setLogo] = useState('');
    const [supplierDetail, setSupplierDetail] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const supplierInformationSchema = Yup.object().shape({
        entityName: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        pointOfContact: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        Mas90VendorNumber: Yup.string()
            .transform((v) => (v == null ? '' : String(v).trim()))
            .min(1, "Minimum 1 symbol")
            .max(20, "Maximum 20 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        postalAddress: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        // postalCity: Yup.string()
        //     .min(3, "Minimum 3 symbols")
        //     .max(50, "Maximum 50 symbols")
        //     .required(
        //         intl.formatMessage({
        //             id: "AUTH.VALIDATION.REQUIRED_FIELD",
        //         })
        //     ),
        postalZipcode: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(5, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        physicalAddress: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        // physicalCity: Yup.string()
        //     .min(3, "Minimum 3 symbols")
        //     .max(50, "Maximum 50 symbols")
        //     .required(
        //         intl.formatMessage({
        //             id: "AUTH.VALIDATION.REQUIRED_FIELD",
        //         })
        //     ),
        physicalZipcode: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(5, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        description: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(500, "Maximum 500 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        email: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const handleCancel = () => {
        setSelectedSupplier(initialValues)
        setOpenSupplier(false);
        setEdit(false);
        setSupplierDetail(null);
    }

    const supplierRowId = supplierIdToString(supplierInformation._id);

    useEffect(() => {
        if (!edit || !supplierRowId) {
            setSupplierDetail(null);
            setDetailLoading(false);
            return;
        }
        let cancelled = false;
        setDetailLoading(true);
        fetchSuppliers(supplierRowId, accessToken)
            .then((res) => {
                if (!cancelled) setSupplierDetail(res.data);
            })
            .catch((err) => {
                console.error('Failed to load supplier for edit', err);
                if (!cancelled) setSupplierDetail(null);
            })
            .finally(() => {
                if (!cancelled) setDetailLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [edit, supplierRowId, accessToken]);

    const formSourceSupplier = useMemo(() => {
        if (!edit) return supplierInformation;
        return supplierDetail || supplierInformation;
    }, [edit, supplierDetail, supplierInformation]);

    const mergedFormInitialValues = useMemo(
        () => ({ ...initialValues, ...normalizeSupplierForForm(formSourceSupplier) }),
        [initialValues, formSourceSupplier]
    );

    useEffect(() => {
        const src = edit ? (supplierDetail || supplierInformation) : supplierInformation;
        const n = normalizeSupplierForForm(src);
        setPhysicalCity(n.physicalCity);
        setPostalCity(n.postalCity);
        // Intentionally omit supplierInformation: sync when switching supplier or when full detail loads, not on every prop identity change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [edit, supplierRowId, supplierDetail]);

    const supplierFormik = useFormik({
        initialValues: mergedFormInitialValues,
        enableReinitialize: true,
        validationSchema: supplierInformationSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            try {
                if(edit){
                    values.physicalCity = physicalCity;
                    values.postalCity = postalCity;
                    const idForPatch = supplierIdToString(
                        (supplierDetail && supplierDetail._id) || supplierInformation._id
                    );
                    updateSupplierInformation(idForPatch, values, accessToken).then((response) => {
                        setShowSnackbar(!showSnackbar);
                        setSelectedSupplier(initialValues)
                        setOpenSupplier(false);
                        setEdit(!edit);
                    })
                }
                else{
                    values.physicalCity = physicalCity;
                    values.postalCity = postalCity;
                    let data = {
                        values: values,
                        type: 'admin'
                    }
                    createExternalSupplier(data, accessToken).then((response) => {
                        setShowSnackbar(true);
                        setSelectedSupplier(initialValues)
                        setOpenSupplier(false);

                    })
                }
            } catch (e) {
                alert("An error occurred");
                console.log(e.message);
            }
        }
    });


    return (
        <>
            <Card>
                {edit ? <CardHeader title="Edit Distribution Company"/> : <CardHeader title="New Distribution Company"/> }
                <CardBody>
                    {edit && detailLoading ? (
                        <div className="py-10 text-center text-muted">Loading supplier…</div>
                    ) : null}
                    {edit && detailLoading ? null : (
                    <form onSubmit={supplierFormik.handleSubmit}>
                        <div>
                            <div className="">
                                <div className="col-12">
                                    <Grid container>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Supplier</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="entityName"
                                                        {...supplierFormik.getFieldProps("entityName")}
                                                    />
                                                    {supplierFormik.touched.entityName && supplierFormik.errors.entityName ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.entityName}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Point of Contact</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="pointOfContact"
                                                        {...supplierFormik.getFieldProps("pointOfContact")}
                                                    />
                                                    {supplierFormik.touched.pointOfContact && supplierFormik.errors.pointOfContact ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.pointOfContact}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Mas90 Vendor Number</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="Mas90VendorNumber"
                                                        {...supplierFormik.getFieldProps("Mas90VendorNumber")}
                                                    />
                                                    {supplierFormik.touched.Mas90VendorNumber && supplierFormik.errors.Mas90VendorNumber ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.Mas90VendorNumber}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Phone Number</InputLabel>
                                                    <Input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="phoneNumber"
                                                        inputComponent={TextMaskCustom}
                                                        {...supplierFormik.getFieldProps("phoneNumber")}
                                                    />
                                                    {supplierFormik.touched.phoneNumber && supplierFormik.errors.phoneNumber ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.phoneNumber}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Email</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="email"
                                                        {...supplierFormik.getFieldProps("email")}
                                                    />
                                                    {supplierFormik.touched.email && supplierFormik.errors.email ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.email}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>

                                            </Grid>
                                            
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Postal Address</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="postalAddress"
                                                        {...supplierFormik.getFieldProps("postalAddress")}
                                                    />
                                                    {supplierFormik.touched.postalAddress && supplierFormik.errors.postalAddress ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.postalAddress}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Physical Address</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="physicalAddress"
                                                        {...supplierFormik.getFieldProps("physicalAddress")}
                                                    />
                                                    {supplierFormik.touched.physicalAddress && supplierFormik.errors.physicalAddress ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.physicalAddress}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Postal City</InputLabel>
                                                    <PuertoRicoMunicipalitySelect
                                                        name="postalCity"
                                                        className={`form-control form-control-solid h-2 py-2 px-6`}
                                                        inputComponent={
                                                            <FilledInput
                                                                name="postalCity"
                                                                id="postalCity"
                                                                type="text"
                                                                className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                {...supplierFormik.getFieldProps("postalCity")}
                                                            />
                                                        }
                                                        value={postalCity}
                                                        placeholder="Municipio"
                                                        onBlur={supplierFormik.handleBlur}
                                                        onChange={(val) => {
                                                            setPostalCity(val);
                                                            supplierFormik.setFieldValue("postalCity", val);
                                                        }}
                                                    />
                                                    {supplierFormik.touched.postalCity && supplierFormik.errors.postalCity ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{supplierFormik.errors.postalCity}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Physical City</InputLabel>
                                                    <PuertoRicoMunicipalitySelect
                                                        name="physicalCity"
                                                        className={`form-control form-control-solid h-2 py-2 px-6`}
                                                        inputComponent={
                                                            <FilledInput
                                                                name="physicalCity"
                                                                id="physicalCity"
                                                                type="text"
                                                                className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                {...supplierFormik.getFieldProps("physicalCity")}
                                                            />
                                                        }
                                                        value={physicalCity}
                                                        placeholder="Municipio"
                                                        onBlur={supplierFormik.handleBlur}
                                                        onChange={(val) => {
                                                            setPhysicalCity(val);
                                                            supplierFormik.setFieldValue("physicalCity", val);
                                                        }}
                                                    />
                                                    {supplierFormik.touched.physicalCity && supplierFormik.errors.physicalCity ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{supplierFormik.errors.physicalCity}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Postal Zip Code</InputLabel>
                                                    <input
                                                        type="text"
                                                        placeholder="00000"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="postalZipcode"
                                                        {...supplierFormik.getFieldProps("postalZipcode")}
                                                    />
                                                    {supplierFormik.touched.postalZipcode && supplierFormik.errors.postalZipcode ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.postalZipcode}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Physical Zip Code</InputLabel>
                                                    <input
                                                        type="text"
                                                        placeholder="00000"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="physicalZipcode"
                                                        {...supplierFormik.getFieldProps("physicalZipcode")}
                                                    />
                                                    {supplierFormik.touched.physicalZipcode && supplierFormik.errors.physicalZipcode ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.physicalZipcode}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Description of Services</InputLabel>
                                                    <input
                                                        type="text"
                                                        multiline
                                                        className={`form-control form-control-solid h-auto py-4 px-6`}
                                                        name="description"
                                                        {...supplierFormik.getFieldProps("description")}
                                                    />
                                                    {supplierFormik.touched.description && supplierFormik.errors.description ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{supplierFormik.errors.description}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            {/* <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="unitSize">Logo Path</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="units"
                                                        {...supplierFormik.getFieldProps("logoPath")}
                                                    />
                                                    {supplierFormik.touched.logoPath && supplierFormik.errors.logoPath ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{supplierFormik.errors.logoPath}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <Image src={supplierInformation.logoPath} fluid rounded/>
                                            </Grid> */}
                                            {/* <Grid item xs={3}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Is External</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="isExternal" id="isExternal"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...supplierFormik.getFieldProps("isExternal")}
                                                        />}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>

                                                    </Select>
                                                    {supplierFormik.touched.isExternal && supplierFormik.errors.isExternal ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{supplierFormik.errors.isExternal}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid> */}
                                            <Grid item xs={3}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Is Active</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="active" id="active"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...supplierFormik.getFieldProps("active")}
                                                        />}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>

                                                    </Select>
                                                    {supplierFormik.touched.active && supplierFormik.errors.active ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{supplierFormik.errors.active}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary mr-3">
                                Save
                            </button>
                            <button type="button" className="btn btn-light" onClick={() => handleCancel()}>
                                Cancel
                            </button>
                        </div>
                    </form>
                    )}
                </CardBody>
            </Card>
        </>
    );
}

export default injectIntl(EditOrAddSupplier);
